var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 8C9.76395 8 9.16699 8.59695 9.16699 9.33333V12C9.16699 12.7364 9.76395 13.3333 10.5003 13.3333H13.167C13.9034 13.3333 14.5003 12.7364 14.5003 12V9.33333C14.5003 8.59695 13.9034 8 13.167 8H12.8337C12.6496 8 12.5003 8.14924 12.5003 8.33333V9.33333C12.5003 9.70152 12.2018 10 11.8337 10C11.4655 10 11.167 9.70152 11.167 9.33333V8.33333C11.167 8.14924 11.0178 8 10.8337 8H10.5003Z",
    fill: "#031D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83333 8C3.09695 8 2.5 8.59695 2.5 9.33333V12C2.5 12.7364 3.09695 13.3333 3.83333 13.3333H6.5C7.23638 13.3333 7.83333 12.7364 7.83333 12V9.33333C7.83333 8.59695 7.23638 8 6.5 8H6.16667C5.98257 8 5.83333 8.14924 5.83333 8.33333V9.33333C5.83333 9.70152 5.53486 10 5.16667 10C4.79848 10 4.5 9.70152 4.5 9.33333V8.33333C4.5 8.14924 4.35076 8 4.16667 8H3.83333Z",
    fill: "#031D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16634 1.33337C6.42996 1.33337 5.83301 1.93033 5.83301 2.66671V5.33337C5.83301 6.06975 6.42996 6.66671 7.16634 6.66671H9.83301C10.5694 6.66671 11.1663 6.06975 11.1663 5.33337V2.66671C11.1663 1.93033 10.5694 1.33337 9.83301 1.33337H9.49967C9.31558 1.33337 9.16634 1.48261 9.16634 1.66671V2.66671C9.16634 3.0349 8.86786 3.33337 8.49967 3.33337C8.13148 3.33337 7.83301 3.0349 7.83301 2.66671V1.66671C7.83301 1.48261 7.68377 1.33337 7.49967 1.33337H7.16634Z",
    fill: "#031D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledBoxes);
export default __webpack_public_path__ + "static/media/filledBoxes.3a11be5e.svg";
export { ForwardRef as ReactComponent };